/** @jsxImportSource @emotion/react */
"use client";

import { useModal } from "@ebay/nice-modal-react";
import type { FlaggableType } from "@packages/sdk";
import { useRedirects, useSession } from "@packages/sdk";
import type { MouseEventHandler } from "react";
import { forwardRef } from "react";

import type { HallowElement } from "../../../../types/hallowElement.types";
import type { HallowElementProps } from "../../../../types/hallowElementProps.types";
import { FlagRecordModal } from "../FlagRecordModal/FlagRecordModal.emotion";

const Element: HallowElement = "button";

export type FlagRecordButtonProps = HallowElementProps<typeof Element> & {
  flaggableId: number;
  flaggableType: FlaggableType;
};

export const FlagRecordButton = forwardRef<any, FlagRecordButtonProps>(
  ({ flaggableId, flaggableType, onClick, children, ...props }, ref) => {
    const flagRecordModal = useModal(FlagRecordModal);
    const { status } = useSession();
    const { redirectToAuth } = useRedirects();

    const handleClick: MouseEventHandler<HTMLButtonElement> = (event) => {
      if (onClick) onClick(event);
      if (status === "authenticated") {
        flagRecordModal.show({
          flaggableId,
          flaggableType,
        });
      } else {
        return redirectToAuth();
      }
    };

    return (
      <button onClick={handleClick} ref={ref} {...props}>
        {children}
      </button>
    );
  },
);

FlagRecordButton.displayName = "FlagRecordButton";
